import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  menuList?: any
  menuOptionList?: any
  menuDetail?: any
  reloadMenuList?: string | null
  modalMenu?: IModalBase
}

const initialState: IState = {
  menuList: [],
  menuOptionList: [],
  menuDetail: {},
  reloadMenuList: null,
  modalMenu: {
    visible: false,
    record: {}
  }
}

export const menuDucks = createSlice({
  name: 'menu',
  initialState,
  reducers: {

    getListMenu: (state: RootState, action: PayloadAction<any>) => {
      state.menuList = { loading: true, queryStr: action.payload }
    },
    getListMenuSuccess: (state, action: PayloadAction<any>) => {
      state.menuList = { loading: false, ...action.payload }
    },
    getListMenuFail: (state, action: PayloadAction<any>) => {
      state.menuList = { loading: false, ...action.payload }
    },

    getListOptionMenu: (state: RootState, action: PayloadAction<any>) => {
      state.menuOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionMenuSuccess: (state, action: PayloadAction<any>) => {
      state.menuOptionList = { loading: false, ...action.payload }
    },
    getListOptionMenuFail: (state, action: PayloadAction<any>) => {
      state.menuOptionList = { loading: false, ...action.payload }
    },

    getDetailMenu: (state: RootState, action: PayloadAction<any>) => {
      state.menuDetail = { loading: true, id: action.payload }
    },
    getDetailMenuSuccess: (state, action: PayloadAction<any>) => {
      state.menuDetail = { loading: false, ...action.payload }
    },
    getDetailMenuFail: (state, action: PayloadAction<any>) => {
      state.menuDetail = { loading: false, ...action.payload }
    },

    setReloadMenuList: (state: RootState) => {
      state.reloadMenuList = String(moment())
    },
    setModalMenu: (state, action: PayloadAction<IModalBase>) => {
      state.modalMenu = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListMenu,
  getListMenuSuccess,
  getListMenuFail,

  getListOptionMenu,
  getListOptionMenuSuccess,
  getListOptionMenuFail,

  getDetailMenu,
  getDetailMenuSuccess,
  getDetailMenuFail,

  setReloadMenuList,
  setModalMenu
} = menuDucks.actions

export default menuDucks.reducer
